import React from 'react';
import { PaymentCommitmentsC } from '../../../containers/wallet/PaymentCommitments';

const PaymentCommitmentsP: React.FC = () => {
  return <PaymentCommitmentsC />;
};

export default PaymentCommitmentsP;
